import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Form, Breadcrumb } from "react-bootstrap";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import {
  faExclamationCircle,
  faCheckCircle,
  faPlusCircle,
  faTrash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLOR_APP } from "../../constants";
import { useMutation, useLazyQuery } from "@apollo/client";
import { errorSwal, successSwal } from "../../helpers/sweetalert";
import {
  CREATE_OPTION_VALUE,
  DELETE_OPTION_VALUE,
} from "../../graphql/optionValue/mutation";
import { GET_OPTION_VALUES } from "../../graphql/optionValue/query";
import AnimationLoading from "../../components/AnimationLoading";
import useWindowDimensions from "../../helpers/useWindowDimensions";
function SettingsOptionValue() {
  const { history } = useReactRouter();

  const [options, setOptions] = useState([]);
  const [optionsInit, setOptionsInit] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState();
  const [selectIndexEdit, setSelectIndexEdit] = useState(-1);
  const [createOptionValue] = useMutation(CREATE_OPTION_VALUE);
  const [deleteOptionValue] = useMutation(DELETE_OPTION_VALUE);
  const [getOptionValue, { data: optionValueData }] = useLazyQuery(
    GET_OPTION_VALUES,
    { fetchPolicy: "cache-and-network" }
  );
  const [checkshow, setCheckshow] = useState();

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    let SHOP_ID = await localStorage.getItem("SHOP");
    // console.log({ SHOP_ID })
    await getOptionValue({
      variables: {
        where: {
          shop: SHOP_ID,
          isDeleted: false,
        },
        orderBy: "createdAt_DESC",
      },
    });
  };

  useEffect(() => {
    if (optionValueData?.optionValues) {
      // console.log({ optionValueData })
      setOptionsInit(optionValueData?.optionValues?.data);

      let groupOption = _.groupBy(optionValueData?.optionValues?.data, "name");
      let _options = [];
      for (let [key, value] of Object.entries(groupOption)) {
        _options.push({ name: key, value });
      }
      setOptions(_options);
    }
  }, [optionValueData]);

  const _saveSetting = async (index) => {

    if (!options[index].name) {
      errorSwal("ກະລຸນາເພີ່ມຊື່ຕົວເລືອກ ແລະ ຄ່າຢ່າງຫນ້ອຍຫນຶ່ງຄ່າກ່ອນບັນທຶກ");
      return;
    }

    const SHOP_ID = await localStorage.getItem("SHOP");

    try {
      setIsLoading(true);
      for (let i = 0; i < options[index].value.length; i++) {
        await createOptionValue({
          variables: {
            data: {
              name: options[index].name ?? "",
              value: options[index].value[i] ?? "",
              shop: SHOP_ID,
              isDeleted: false,
            },
          },
        });
      }

      // console.log(options)
      setEditMode(false);

      let _options = [...options];
      let modifyOption = options[index].value.map((op) => {
        return { name: options[index].name, value: op };
      });
      _options[index] = {
        name: options[index].name,
        value: modifyOption,
      };
      // console.log({ _options })
      setOptions(_options);
      successSwal("ຕັ້ງຄ່າຕົວເລືອກສໍາເລັດ");
      // getSettings()
      setIsLoading(false);
      window.location.reload();
      _addNewTag();
    } catch (err) {
      errorSwal("ມີຂໍ້ຜິດພາດ");
    }
  };

  const _editSetting = async (index, itemOption) => {
    if (!options[index].name) {
      errorSwal("ກະລຸນາເພີ່ມຊື່ຕົວເລືອກ ແລະ ຄ່າຢ່າງຫນ້ອຍຫນຶ່ງຄ່າກ່ອນບັນທຶກ");
      return;
    }

    let SHOP_ID = await localStorage.getItem("SHOP");

    try {
      setIsLoading(true);
      const currentOption = { ...options[index] };
      const currentOptionInit = { ...optionsInit };

      //deleteall option value
      let _filterOption = _.filter(currentOptionInit, {
        name: itemOption?.name,
      });
      for (let i = 0; i < _filterOption.length; i++) {
        await deleteOptionValue({
          variables: {
            where: {
              id: _filterOption[i].id,
            },
          },
        });
      }

      let _optionSplit;
      if (Array.isArray(currentOption.value)) {
        _optionSplit = currentOption.value;
      } else _optionSplit = currentOption.value.split(",");

      for (let i = 0; i < _optionSplit.length; i++) {
        await createOptionValue({
          variables: {
            data: {
              name: currentOption.name ?? "",
              value: _optionSplit[i] ?? "",
              shop: SHOP_ID,
              isDeleted: false,
            },
          },
        });
      }
      successSwal("ຕັ້ງຄ່າຕົວເລືອກສໍາເລັດ");
      setEditMode(false);
      // getSettings()
      setIsLoading(false);
      window.location.reload();
    } catch (err) {
      console.log(err);
      errorSwal("ມີຂໍ້ຜິດພາດ");
    }
  };

  const _addNewTag = () => {
    if (options.length > 0 && !options[options.length - 1].name) {
      errorSwal("ກໍານົດຄ່າໃສ່ຕົວເລືອກທີ່ເພີ່ມກ່ອນຫນ້ານີ້ກ່ອນ");
      return;
    }

    let _optionName = "";
    let _optionValue = [];
    let _options = [...options, { name: _optionName, value: _optionValue }];
    setOptions(_options);
    setSelectIndexEdit(_options.length - 1);
  };

  const _removeOption = async () => {
    let _options = [...options];

    if (options[deleteIndex]) {
      options[deleteIndex].value.map(async (opValue, index) => {
        deleteOptionValue({
          variables: {
            where: {
              id: opValue.id,
            },
          },
        });
      });
    }

    _options.splice(deleteIndex, 1);
    setOptions(_options);

    if (!_options[_options.length - 1].name) {
      _options.splice(_options.length - 1, 1);
    }
    setShowDeleteModal(false);
    successSwal("ຕັ້ງຄ່າຕົວເລືອກສໍາເລັດ");
  };

  const _removeOneOption = async (item) => {
    await deleteOptionValue({
      variables: {
        where: {
          id: item.id,
        },
      },
    });

    let _newOptions = options.map((e) => {
      _.remove(e.value, { id: item.id });
      return {
        ...e,
        value: e.value,
      };
    });
    setOptions(_newOptions);
  };

  const _editOneOption = async (index) => {
    setSelectIndexEdit(index);
    let _options = [...options];
    let _formValue = "";
    _options[index].value.map((opValue, yIndex) => {
      if (_options[index].value.length == yIndex + 1)
        _formValue = _formValue + opValue.value;
      else _formValue = _formValue + opValue.value + ",";
    });
    _options[index].value = _formValue;
    setOptions(_options);
    setEditMode(true);
  };
  const { width, height } = useWindowDimensions();
  return (
    <div>
      {width > 700 ? (
        <div>
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.replace("/settings")}>
              ຕັ້ງຄ່າ
            </Breadcrumb.Item>
            <Breadcrumb.Item active>ຕັ້ງຄ່າຕົວເລືອກຂອງສິນຄ້າ</Breadcrumb.Item>
          </Breadcrumb>
          {isLoading ? <AnimationLoading /> : <div />}
          <div style={{ height: 10 }} />
          <div className="row">
            <div className="col-8">
              <button
                disabled={editMode}
                className="btn btn-app col-2 hoverme"
                style={{
                  float: "right",
                  background: COLOR_APP,
                  color: "#fff",
                }}
                onClick={_addNewTag}
              >
                {" "}
                <FontAwesomeIcon icon={faPlusCircle} /> ເພີ່ມຕົວເລືອກ
              </button>
              <Table
                responsive
                className="staff-table-list borderless table-hover"
                style={{ background: "#fff" }}
              >
                <thead style={{ background: COLOR_APP, color: "#fff" }}>
                  <tr>
                    <th>ລຳດັບ</th>
                    <th>ຊື່ຕົວເລືອກ</th>
                    <th>ຕົວເລືອກ</th>
                    <th>ຈັດການ</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#eee" }}>
                  {options.map((itemOption, index) => (
                    <tr key={"itemOption" + index}>
                      <td>{index + 1}</td>
                      <td>
                        {selectIndexEdit == index ? (
                          <Form.Control
                            onChange={(e) => {
                              let _options = [...options];
                              _options[index].name = e.target.value;
                              setOptions(_options);
                            }}
                            type="text"
                            placeholder="ຊື່ຕົວເລືອກ..."
                            disabled={editMode}
                            value={itemOption.name || ""}
                          />
                        ) : (
                          <p style={{ margin: 0 }}>{options[index].name}</p>
                        )}
                      </td>
                      <td>
                        {selectIndexEdit == index ? (
                          <Form.Control
                            onChange={(e) => {
                              let _options = [...options];
                              _options[index].value = e.target.value.split(",");
                              setOptions(_options);
                            }}
                            type="text"
                            placeholder="ຕົວເລືອກ..."
                            value={itemOption.value || ""}
                          />
                        ) : (
                          <div className="row">
                            {options[index].value.map((opValue, yindex) => (
                              <div
                                key={"options-" + yindex}
                                style={{ position: "relative" }}
                                className="col-4"
                              >
                                <p
                                  className="text-center"
                                  style={{
                                    margin: 1,
                                    padding: 3,
                                    paddingTop: 0,
                                    borderRadius: 8,
                                    border: "1px solid #fff",
                                  }}
                                >
                                  {opValue?.value}
                                </p>
                                <p
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    marginTop: -8,
                                    right: 10,
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={() => _removeOneOption(opValue)}
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </p>
                              </div>
                            ))}
                          </div>
                        )}
                      </td>
                      {selectIndexEdit == index ? (
                        <td className="row" style={{ margin: 0 }}>
                          <button
                            className="btn hoverme btn-outline-primary col"
                            style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                            onClick={() =>
                              !editMode
                                ? _saveSetting(index)
                                : _editSetting(index, itemOption)
                            }
                          >
                            <FontAwesomeIcon icon={faCheckCircle} /> ບັນທຶກ
                          </button>
                        </td>
                      ) : (
                        <td className="row" style={{ margin: 0 }}>
                          <button
                            disabled={editMode}
                            className="btn hoverme btn-outline-primary col"
                            style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                            onClick={() => _editOneOption(index)}
                          >
                            <FontAwesomeIcon icon={faCheckCircle} /> ແກ້ໄຂ
                          </button>
                          <div style={{ width: 5 }} />
                          <button
                            disabled={editMode}
                            className="btn hoverme btn-danger col"
                            onClick={async () => {
                              setDeleteIndex(index);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} /> ລຶບ
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-4">
              <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>
                ຄໍາແນະນໍາການຕັ້ງຄ່າ
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>
                ກໍານົດປະເພດຂອງສິນຄ້າເພື່ອສະດວກໃນການຄວບຄຸມສາງ ສາມາດເພີ່ມປະເພດ ຫຼື
                ຕົວເລືອກຂອງສິນຄ້າໄດ້ຫຼາຍກວ່າຫນຶ່ງຢ່າງໃນແຕ່ລະປະເພດ
              </p>
            </div>
          </div>

          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <div>ຢືນຢັນການລຶບ</div>
            </Modal.Header>
            <Modal.Body
              style={{
                padding: 24,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ fontSize: 90, color: "orange" }}
              />
              <br />
              <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບຕົວເລືອກນີ້ແທ້ບໍ່?</h5>
            </Modal.Body>
            <Modal.Footer
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="outline-dark"
                className="btn btn-app hoverme"
                style={{ width: 150 }}
                onClick={() => setShowDeleteModal(false)}
              >
                ກັບຄືນ
              </Button>
              <div style={{ width: 24 }} />
              <button
                className="btn btn-app hoverme"
                style={{
                  float: "left",
                  background: "red",
                  color: "#fff",
                  width: 150,
                }}
                onClick={() => _removeOption()}
              >
                ລຶບ
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      ) : (
        <div style={{ marginTop: 50 }}>
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.replace('/settings')}>ຕັ້ງຄ່າ</Breadcrumb.Item>
            <Breadcrumb.Item active>ຕັ້ງຄ່າຕົວເລືອກຂອງສິນຄ້າ</Breadcrumb.Item>
          </Breadcrumb>
          <div style={{ margin: '0px 13px' }}>
            <div >
              <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>
                ຄໍາແນະນໍາການຕັ້ງຄ່າ
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>
                ກໍານົດປະເພດຂອງສິນຄ້າເພື່ອສະດວກໃນການຄວບຄຸມສາງ ສາມາດເພີ່ມປະເພດ ຫຼື
                ຕົວເລືອກຂອງສິນຄ້າໄດ້ຫຼາຍກວ່າຫນຶ່ງຢ່າງໃນແຕ່ລະປະເພດ
              </p>
            </div>
            {isLoading ? <AnimationLoading /> : <div />}
            <div style={{ height: 10 }} />
            <div>
              <div >
                <button
                  disabled={editMode}
                  className="btn btn-app hoverme"
                  style={{
                    float: "right",
                    color: "black",
                    background: "#E8EDF1",
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                  onClick={_addNewTag}
                >
                  {" "}
                  <FontAwesomeIcon icon={faPlusCircle} /> ເພີ່ມຕົວເລືອກ
                </button>
                <Table
                  responsive
                  className="staff-table-list borderless table-hover"
                  style={{ background: "#fff" }}
                >
                  <thead style={{ background: "#eee", color: "#252A31", fontSize: 14 }}>
                    <tr>
                      <th>#</th>
                      <th>ຊື່ຕົວເລືອກ</th>
                      <th>ຕົວເລືອກ</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody style={{ background: "#eee" }}>
                    {options.map((itemOption, index) => (
                      <tr key={"itemOption" + index}>
                        <td>{index + 1}</td>
                        <td>
                          {selectIndexEdit == index ? (
                            <Form.Control
                              onChange={(e) => {
                                let _options = [...options];
                                _options[index].name = e.target.value;
                                setOptions(_options);
                              }}
                              type="text"
                              placeholder="ຊື່ຕົວເລືອກ..."
                              disabled={editMode}
                              value={itemOption.name || ""}
                            />
                          ) : (
                            <p style={{ margin: 0 }}>{options[index].name}</p>
                          )}
                        </td>
                        <td>
                          {selectIndexEdit == index ? (
                            <Form.Control
                              onChange={(e) => {
                                let _options = [...options];
                                _options[index].value = e.target.value.split(",");
                                setOptions(_options);
                              }}
                              type="text"
                              placeholder="ຕົວເລືອກ..."
                              value={itemOption.value || ""}
                            />
                          ) : (
                            <div className="row">
                              {options[index].value.map((opValue, yindex) => (
                                <div
                                  key={"options-" + yindex}
                                  style={{ position: "relative" }}
                                  className="col-4"
                                >
                                  <p
                                    className="text-center"
                                    style={{
                                      margin: 1,
                                      padding: 3,
                                      paddingTop: 0,
                                      borderRadius: 8,
                                      border: "1px solid #fff",
                                    }}
                                  >
                                    {opValue?.value}
                                  </p>
                                  <p
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      marginTop: -8,
                                      right: 10,
                                      cursor: "pointer",
                                      color: "red",
                                    }}
                                    onClick={() => _removeOneOption(opValue)}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                        </td>
                        {selectIndexEdit == index ? (
                          <td className="row" style={{ margin: 0 }}>
                            <button
                              className="btn hoverme btn-outline-primary"
                              style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                              onClick={() =>
                                !editMode
                                  ? _saveSetting(index)
                                  : _editSetting(index, itemOption)
                              }
                            >
                              <FontAwesomeIcon icon={faCheckCircle} /> ບັນທຶກ
                            </button>
                          </td>
                        ) : (
                          <td className="row" style={{ margin: 0 }}>
                            {/* <button
                            disabled={editMode}
                            className="btn hoverme btn-outline-primary col"
                            style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                            onClick={() => _editOneOption(index)}
                          >
                            <FontAwesomeIcon icon={faCheckCircle} /> ແກ້ໄຂ
                          </button> */}
                            {/* <div style={{ width: 5 }} /> */}
                            <button
                              disabled={editMode}
                              className="btn hoverme btn-danger"
                              onClick={async () => {
                                setDeleteIndex(index);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

            </div>

          </div>
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <div>ຢືນຢັນການລຶບ</div>
            </Modal.Header>
            <Modal.Body
              style={{
                padding: 24,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ fontSize: 90, color: "orange" }}
              />
              <br />
              <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບຕົວເລືອກນີ້ແທ້ບໍ່?</h5>
            </Modal.Body>
            <Modal.Footer
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="outline-dark"
                className="btn btn-app hoverme"
                style={{ width: 150 }}
                onClick={() => setShowDeleteModal(false)}
              >
                ກັບຄືນ
              </Button>
              <div style={{ width: 24 }} />
              <button
                className="btn btn-app hoverme"
                style={{
                  float: "left",
                  background: "red",
                  color: "#fff",
                  width: 150,
                }}
                onClick={() => _removeOption()}
              >
                ລຶບ
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </div>
  );
}

export default SettingsOptionValue;
